import {
  CREATE_CONSIGNMENT_ORDER_REFUND,
  DELETE_CONSIGNMENT_ORDER_REFUND,
  GET_CONSIGNMENT_ORDER_REFUND_BY_CONSIGNMENT_ORDER_ID,
  GET_CONSIGNMENT_ORDER_REFUND_BY_ID,
  UPDATE_CONSIGNMENT_ORDER_REFUND,
} from '../types';

const initialState = {
  consignmentOrderRefund: [],
  consignmentOrderRefundById: {},
  consignmentOrderRefundDelete: null,
  consignmentOrderRefundByConsigmentOrder: [],
};

export default function ConsignmentOrderRefund(state = initialState, action) {
  switch (action.type) {
    case GET_CONSIGNMENT_ORDER_REFUND_BY_CONSIGNMENT_ORDER_ID:
      return {
        ...state,
        consignmentOrderRefundByConsigmentOrder: action.payload,
      };
    case CREATE_CONSIGNMENT_ORDER_REFUND:
      return {
        ...state,
        consignmentOrderRefund: [
          ...state.consignmentOrderRefund,
          action.payload,
        ],
      };
    case GET_CONSIGNMENT_ORDER_REFUND_BY_ID:
      return {
        ...state,
        consignmentOrderRefundById: action.payload,
      };
    case UPDATE_CONSIGNMENT_ORDER_REFUND:
      return {
        ...state,
        consignmentOrderRefund: state.consignmentOrderRefund.map((refund) =>
          refund.id === action.payload.id ? action.payload : refund
        ),
      };
    case DELETE_CONSIGNMENT_ORDER_REFUND:
      return {
        ...state,
        consignmentOrderRefund: state.consignmentOrderRefund.map((refund) =>
          refund.id === action.payload.id ? action.payload : refund
        ),
      };
    default:
      return state;
  }
}
